import { render, staticRenderFns } from "./AdvisorySchools.vue?vue&type=template&id=5a7e1b1f"
import script from "./AdvisorySchools.vue?vue&type=script&lang=js"
export * from "./AdvisorySchools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports